<template>
  <ContentContainer
    class="grid grid-cols-1 gap-6 mb-20 items-start overflow-visible max-w-[856px]! px-0!"
  >
    <slot name="contentBlocks" />
  </ContentContainer>
</template>

<script setup lang="ts">
defineSlots<{
  contentBlocks(): any;
}>();
</script>
